import React, { useContext } from 'react';
import './Type4.scss';
import intl from 'react-intl-universal';
import { getGalleryStatus } from '../../utils/util';
import { IGalleryType, IGalleryData, IGalleryList } from './GalleryType';
import { inject, observer } from 'mobx-react';
import Lock from './Lock';
import StatisticsRow from '../StatisticsRow';
import StatusTag from '../Tag/StatusTag';
import classNames from 'classnames';
import { IGalleryStatus, IViewDetail } from '../../global.d';
import { direct } from '../../utils/image';
import { ThemeContext } from '../../store/ThemeProvider';
import uImageCount from './useImageCount';
import { renderGalleryName } from './AllForGallery';
import { resolveLocaleText } from '../../utils/localeText';

const Type4 = (props: IGalleryType) => {
  const {
    image,
    link,
    gallerys = {} as IGalleryList,
    info = true,
    total = true,
    // showname = true,
    namealign = 'left',
    imageadjust = false,
    desc
  } = props;

  const showname = true;

  const { h1Color, h2Color } = useContext(ThemeContext);
  const loc = intl.getInitOptions().currentLocale;
  const displayName = resolveLocaleText(
    link ? link.desc : desc,
    (link && link.desc_i18n) || props.desc_i18n,
    loc
  );

  const { view_detail, image_total, gallery } =
    ['subgallery', 'gallery'].indexOf(link.type) > -1
      ? uImageCount(link, gallerys)
      : {
          view_detail: null,
          image_total: 0,
          gallery: {
            name: desc,
            status: '',
            start_time: '',
            end_time: '',
            is_pay_down:0
          }
        };

  return (
    <div
      className="type4-wrapper type-wrapper bb"
      onClick={() => {
        props.onClick(link);
      }}
    >
      <div className="type4-left">
        {showname ? <div className={"name " + namealign}>
          <div className="real-name">{renderGalleryName((gallery || {}).name, displayName)}</div>
        </div> : null}
        <div className="bottom-row">
          {gallery && Number(gallery.is_pay_down) ? <StatusTag
            status={IGalleryStatus.needpay}
            style={{ marginRight: 5 }}
            className={'status'}
            fontSize={12}
          /> : null}
          {info ? (
            <StatusTag
              status={(gallery || {}).status as IGalleryStatus}
              style={{ marginRight: 15 }}
              fontSize={11}
              startTime={(gallery || ({} as IGalleryData)).start_time}
              endTime={(gallery || ({} as IGalleryData)).end_time}
            />
          ) : null}
          {!!view_detail && total ? (
            <StatisticsRow
              n1={image_total || 0}
              n2={view_detail.view || 0}
              fontSize={11}
              fontColor={h2Color}
            />
          ) : null}
        </div>
      </div>
      <div className="type4-right">
        {/*<img
          src={require('../../assets/lock.png')}
          className={'lock-img'}
          alt="lock"
        />*/}
        <span className="icon-right-arrow" style={{ color: h2Color }} />
      </div>
    </div>
  );
};

export default Type4;
